import { Phone, MapPin, Shield } from "lucide-react";

/*
 * AreasHero — Section 1/8 for /service-areas/
 * Navy hero with SEO-targeted H1, suburb count, credibility strip.
 * Paste this ENTIRE file into src/pages/ServiceAreas/sections/AreasHero.tsx
 * replacing the placeholder content.
 */

const GOLD = "#F5A623";
const NAVY = "#081438";
const NAVY2 = "#0f2347";
const STATS = [{
  value: "8+",
  label: "Brands Serviced"
}, {
  value: "1-Year",
  label: "Labour Warranty"
}, {
  value: "217+",
  label: "Suburbs Covered"
}, {
  value: "5.0 ★",
  label: "Google Rating"
}];
const REGIONS = ["Eastern Suburbs", "Western Sydney", "North Shore", "Inner West", "Northern Beaches", "Hills District", "Sutherland Shire", "South Sydney", "Canterbury-Bankstown", "Wollongong", "Central Coast", "Blue Mountains"];
export default function AreasHero() {
  return <section id="areas-hero" style={{
    background: NAVY,
    position: "relative",
    overflow: "hidden"
  }}>

      {/* ── Grain ── */}
      <svg aria-hidden="true" style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none",
      zIndex: 1
    }}>
        <filter id="ah-grain"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#ah-grain)" />
      </svg>

      {/* ── Radial glow ── */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: "-20%",
      left: "-10%",
      width: "60%",
      height: "140%",
      background: `radial-gradient(ellipse,${NAVY2}CC 0%,transparent 70%)`,
      pointerEvents: "none",
      zIndex: 1
    }} />

      {/* ── Top scanline ── */}
      <div aria-hidden="true" style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "2px",
      background: `linear-gradient(90deg,transparent,${GOLD},transparent)`,
      zIndex: 2
    }} />

      {/* ── Watermark ── */}
      <div aria-hidden="true" style={{
      position: "absolute",
      bottom: "-2%",
      right: "-2%",
      fontSize: "clamp(100px,18vw,260px)",
      fontWeight: 900,
      color: `${GOLD}0A`,
      lineHeight: 1,
      fontFamily: "Plus Jakarta Sans,sans-serif",
      pointerEvents: "none",
      zIndex: 1,
      userSelect: "none",
      letterSpacing: "-0.04em"
    }}>
        217+
      </div>

      {/* ── Main content ── */}
      <div style={{
      position: "relative",
      zIndex: 3,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "clamp(80px,10vw,120px) clamp(20px,5vw,48px) 0",
      textAlign: "center"
    }}>

        {/* Pill */}
        <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        background: `${GOLD}18`,
        border: `1px solid ${GOLD}35`,
        borderRadius: "999px",
        padding: "6px 16px",
        marginBottom: "28px"
      }}>
          {/** @preserve lucide-do-not-replace */}
          <span data-icon-container="lucide-do-not-replace"><MapPin size={13} color={GOLD} strokeWidth={2} /></span>
          <span style={{
          color: GOLD,
          fontSize: "12px",
          fontWeight: 700,
          fontFamily: "Manrope,sans-serif",
          letterSpacing: "0.06em",
          textTransform: "uppercase"
        }}>
            12 Regions · 217+ Suburbs
          </span>
        </div>

        {/* H1 */}
        <h1 style={{
        fontFamily: "Plus Jakarta Sans,sans-serif",
        fontWeight: 800,
        fontSize: "clamp(30px,4.5vw,58px)",
        lineHeight: 1.07,
        color: "#FFFFFF",
        marginBottom: "20px",
        maxWidth: "800px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          Garage Door Repair &amp; Service<br />
          <span style={{
          color: GOLD
        }}>Across All of Sydney</span>
        </h1>

        <p style={{
        fontFamily: "Manrope,sans-serif",
        fontSize: "clamp(15px,1.7vw,18px)",
        color: "rgba(255,255,255,0.7)",
        lineHeight: 1.7,
        marginBottom: "16px",
        maxWidth: "580px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          Same-day garage door repairs, motor service &amp; new installs — from the Eastern Suburbs to the Blue Mountains. Family-run since 2009.
        </p>

        {/* Trust line */}
        <div style={{
        display: "inline-flex",
        alignItems: "center",
        gap: "6px",
        marginBottom: "36px"
      }}>
          {/** @preserve lucide-do-not-replace */}
          <span data-icon-container="lucide-do-not-replace"><Shield size={14} color={GOLD} strokeWidth={2} /></span>
          <span style={{
          fontFamily: "Manrope,sans-serif",
          fontSize: "13px",
          color: `${GOLD}BB`,
          fontWeight: 600
        }}>
            1-Year Labour Warranty on every job, every suburb
          </span>
        </div>

        {/* CTAs */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "12px",
        justifyContent: "center",
        marginBottom: "44px"
      }}>
          <a href="tel:0485000933" style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          background: GOLD,
          color: NAVY,
          padding: "14px 28px",
          borderRadius: "8px",
          fontFamily: "Manrope,sans-serif",
          fontWeight: 700,
          fontSize: "15px",
          textDecoration: "none",
          boxShadow: `0 4px 20px ${GOLD}45`
        }}>
            {/** @preserve lucide-do-not-replace */}
            <span data-icon-container="lucide-do-not-replace"><Phone size={17} color={NAVY} strokeWidth={2.5} /></span>
            0485 000 933
          </a>
          <a href="#contact-us" style={{
          display: "inline-flex",
          alignItems: "center",
          background: "rgba(255,255,255,0.08)",
          color: "#FFF",
          border: "1.5px solid rgba(255,255,255,0.22)",
          padding: "14px 28px",
          borderRadius: "8px",
          fontFamily: "Manrope,sans-serif",
          fontWeight: 600,
          fontSize: "15px",
          textDecoration: "none"
        }}>
            Get Free Quote
          </a>
        </div>

        {/* Region chips */}
        <div style={{
        display: "flex",
        flexWrap: "wrap",
        gap: "8px",
        justifyContent: "center",
        maxWidth: "720px",
        marginLeft: "auto",
        marginRight: "auto"
      }}>
          {REGIONS.map(r => <span key={r} style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "4px",
          background: "rgba(255,255,255,0.06)",
          border: "1px solid rgba(255,255,255,0.1)",
          borderRadius: "999px",
          padding: "5px 13px",
          fontFamily: "Manrope,sans-serif",
          fontSize: "12px",
          color: "rgba(255,255,255,0.6)",
          fontWeight: 500
        }}>
              {/** @preserve lucide-do-not-replace */}
              <span data-icon-container="lucide-do-not-replace"><MapPin size={10} color={GOLD} strokeWidth={2} /></span>
              {r}
            </span>)}
        </div>
      </div>

      {/* ── Credibility strip ── */}
      <div style={{
      position: "relative",
      zIndex: 3,
      maxWidth: "1280px",
      margin: "0 auto",
      padding: "0 clamp(20px,5vw,48px)"
    }}>
        <div style={{
        display: "grid",
        gridTemplateColumns: "repeat(auto-fit,minmax(130px,1fr))",
        borderTop: `1px solid ${GOLD}20`,
        marginTop: "52px",
        paddingTop: "28px",
        paddingBottom: "28px"
      }}>
          {STATS.map(s => <div key={s.label} style={{
          textAlign: "center",
          padding: "8px 12px"
        }}>
              <div style={{
            fontFamily: "Plus Jakarta Sans,sans-serif",
            fontWeight: 800,
            fontSize: "clamp(20px,2.5vw,28px)",
            color: GOLD,
            lineHeight: 1
          }}>{s.value}</div>
              <div style={{
            fontFamily: "Manrope,sans-serif",
            fontSize: "11px",
            color: "rgba(255,255,255,0.5)",
            marginTop: "4px",
            fontWeight: 500
          }}>{s.label}</div>
            </div>)}
        </div>
      </div>

      {/* ── Wave bottom — DUPLICATE in AreasGrid top ── */}
      <div style={{
      position: "relative",
      zIndex: 3,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 60" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        width: "100%",
        display: "block"
      }}>
          <path d="M0,0 C360,60 1080,60 1440,0 L1440,60 L0,60 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}